export default {
  NEW: 'new',
  EXISTING: 'existing',
};
